import { useEffect, useRef } from 'react';

/**
 * Wrapper for elements to handle banenr description.
 *
 * Add an id to the corresponding item(s), and wrap them inside this component.
 *
 * - redirectToSyncee (data attribute: syncee-com-path)
 * - redirectToHelpCenter
 *
 * @example <u id="redirectToSyncee" data-syncee-com-path="/">Open on syncee.com</u>
 * */
const TranslationClickListener: React.FC<BannerClickListenerProps> = ({ children, id, action }) => {
    const element = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClick = (ev: MouseEvent) => {
            const target = ev.target as HTMLElement;
            switch (target?.id) {
                case 'redirectToHelpCenter':
                    open('https://help.syncee.com', '_blank');
                    break;
                case id:
                    action?.();
                    break;
            }
        };
        if (element.current) {
            element.current.addEventListener('click', handleClick);
        }

        return () => {
            if (element.current) {
                element.current.removeEventListener('click', handleClick);
            }
        };
    }, [element.current, id, action]);

    return <div ref={element}>{children}</div>;
};

export default TranslationClickListener;

interface BannerClickListenerProps {
    id?: string;
    action?: () => void;
    children: React.ReactNode;
}
